module.exports = __webpack_public_path__ + "static/media/015.d06ae4e0.jpg";